/**
 * A per-tab id sent with every API request as `x-client-id`. The live stream
 * echoes it on the batches a tab's own mutations produce, so that tab can skip
 * refetching for its own edits (its mutation hooks already reconcile) while a
 * second tab of the SAME user still updates — phone + laptop is the normal case.
 * sessionStorage: survives reloads, distinct per tab.
 */
const KEY = 'uc-client-id';

function generate(): string {
  return typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

function load(): string {
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) {
      return existing;
    }
    const fresh = generate();
    sessionStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return generate();
  }
}

export const clientId: string = load();
